export default {
  router: {
    index: {
      home: 'home',
      pageSearch1: 'User Query Management',
      pageSearch2: 'User Query',
      pageRoom1: 'Room Management',
      refundDetail: 'Refund the query',

      pageRoom2: 'Room Query',
      pageAppealHall: 'Appeal Hall',
      pageMoreIp: 'View More IP',
      pageMachine1: 'Machine Report',
      pageMachine2: 'Machine Report List',
      pageUser1: 'User Report',
      pageUser2: 'User Report List',
      pageApplicatId1: 'Application ID',
      pageApplicatId2: 'ID Upgrade Query',
      pageBg: 'Room background Check',
      roomColumn: 'Banner management',
      pageActivity: 'Review activities',
      pageGroup: 'Review group',
      reportReview:'Review report',
      pageProblem: 'Customer service workstation',
      pageProblem1: 'Feedback to reply',
      pageProblem2: 'Problem Statistics Details',
      pageService1: 'Work statistics and account management',
      pageService2: 'Customer Service Work Statistics',
      pageKnowledge1: 'Hot QA Management',
      pageKnowledge2: 'Customer Service Knowledge Base',
      pageAccout1: 'Customer service account management',
      pageAccout2: 'Customer service account management list',
      pageFamily1: 'Guild Information Query',
      pageFamily2: 'Family query',
      pageFamily3: 'Guild Members List',
      groupManagement: 'Group Management',
      pageSearch4:'Group Detail',
      //
      login: 'Log In',
      pageAccount1: 'Administrator account settings',
      pageAccount2: 'Administrator account list',
      pageManagement1: 'Role Permission management',
      pageManagement2: 'Role Permission management list',
      // 补
      pageSuperTube1: 'administrator',
      pageSuperTube2: 'Super Administrator',
      pageSuperTube3: 'Country administrator',
      pageQsBank1: 'Problem bank',
      pageQsBank2: 'Customer Service Knowledge Base',
      pageLost1: 'Lost order information query',
      pageLost2: 'Lost order information query list',

      community: 'Square Community Management',
      topicManagement: 'Topic management',
      topicReview: 'User topic audit',
      contentReview: 'Post review',
      reportManagement: 'Report management',
      auditorManagement: 'Auditor management',
      anomaly: 'Report of abnormal operation',
      postingPermiss: 'Post condition setting',
      statistics: 'Daily statistics',
      annualCeremony: 'Annual ceremony',
      broadcastManagement: 'Broadcast review',
      avatarReview: 'Avatar Review',
      avatarReviewDetail: 'Profile review details',
      albumReview: 'Album review',
      cstStatistics: 'CST work statistics',
      omtStatistics: 'OMT work statistics',
      operationLog: 'Operation log',
      loginFeedback1: 'Login Feedback',
      loginFeedback2: 'Login feedback list',
      loginFeedback3: 'Login feedback details',
      systemBlacklist1: 'Account blacklist',
      systemBlacklist2: 'Account blacklist list',
      activitySuppor: 'Activity support statistics',
      couplePage1: 'Couple activity entrance',
      nowMemberInroom1: 'User\'s current room',
      nowMemberInroom2: 'User\'s current room',

      error401: 'error 401',
      error404: 'error 404',
      error500: 'error 500',
    },
    router: {
      beforeClose: {
        sureClose: 'Sure to close this page',
      },
    },
  },
  views: {
    platform: {
      tab1: 'Monthly statistics',
      tab2: 'Daily Statistics',
      tab3: 'Recharge details',
      tab4: 'Gold coin consumption monthly statistics',
      tab5: 'Gold coin consumption daily statistics',
      tab6: 'Task completion details',
      tab7: 'Task statistics',
      tab8: 'Recharge times query',
      tab9: 'Agent recharge details',
      tab10: 'Refund details',
      tab11: 'Freeze details',
      tab1Sub1: 'Data on the day is delayed by about 30 minutes',
      tab1Sub2: 'Data for the current month is calculated with a delay of about 30 minutes',

      platformRechargeDetail1: 'Recharge arrival time',
      platformRechargeDetail2: 'Receiving user id',
      platformRechargeDetail3: 'Name of the accounted user',
      platformRechargeDetail4: 'Amount to the account',
      platformRechargeDetail5: 'Number of gold coins',
      platformRechargeDetail6: 'Currency',
      platformRechargeDetail7: 'Recharge type',
      platformRechargeDetail8: 'order number',
      platformRechargeDetail9: 'Amount in descending order',
      platformRechargeDetail10: 'Amount ascending',
      platformRechargeDetail11: 'Payment Types',
      platformRechargeDetail12: 'Sort',

      platformGoldMonth: 'years',

      platformGoldDay1: 'date',
      platformGoldDay2: 'Gift consumption',
      platformGoldDay3: 'Guessing consumption',
      platformGoldDay4: 'Become a room member',
      platformGoldDay5: 'Full server speaker',
      platformGoldDay6: 'Summon fans',
      platformGoldDay7: 'Summon members',
      platformGoldDay8: 'Top room',
      platformGoldDay9: 'Room lock',
      platformGoldDay10: 'Create room',
      platformGoldDay11: 'Create a family',
      platformGoldDay12: 'mission rewards',
      platformGoldDay13: 'Shop purchase',
      platformGoldDay14: 'other',
      platformGoldDay15: 'pk consumption',
      platformGoldDay16: 'Vote consumption',

      platformDetail: 'User ID',

      platformTask1: 'date',
      platformTask2: 'Serve for 10 minutes',
      platformTask3: 'Serving for 1 hour',
      platformTask4: 'Share room once',
      platformTask5: 'Initiate PK',
      platformTask6: 'Give 3 gifts',
      platformTask7: 'Any level 5',
      platformTask8: 'Any level 10',
      platformTask9: 'Create room',
      platformTask10: 'Launch event',
      platformTask11: 'Composition CP',
      platformTask12: 'Create a family',
      platformTask13: 'First stroke',
      platformTask14: 'total',

      platformRecharge1: 'Receiving user id',
      platformRecharge2: 'Name of the accounted user',
      platformRecharge3: 'Total amount arrived (USD)',
      platformRecharge4: 'Total recharge times',

      payType1: 'WeChat',
      payType2: 'Alipay',
      payType3: 'Apple Pay',
      payType4: 'Google Pay',
      payType5: 'palpay payment',
      payType6: 'Agent recharge',
      payType7: 'Agent internal recharge',
      payType8: 'e-commerce recharge',
      payType9: 'payssion payment',
      payType10: 'tap payment',
      payType11: 'Huawei Pay',
      // payType12: 'Eggplant Express Payment',
      payType12: 'payermax payment',
      payType13: 'dlocal recharge',
      payType14: 'paypal recharge',
      payType15: 'checkout recharge',


      payWay1: 'RMB',
      payWay2: 'USD',

      agentTableText1: 'Acting number',
      agentTableText2: 'User ID',
      agentTableText3: 'Registration time',
      agentTableText4: 'Avatar',
      agentTableText5: 'nickname',
      agentTableText6: 'Top up gold coins',
      agentTableText7: 'Top-up amount (USD)',
      agentTableText8: 'Recharge time',

      table5Text1: 'Refund person',
      table5Text2: 'Refund time',
      table5Text3: 'order number',
      table5Text4: 'User ID',
      table5Text5: 'Please enter your username',
      table5Text6: 'Number of refunded gold coins (US dollars)',
      table5Text7: 'nickname',
      table5Text8: 'country',
      table5Text9: 'Registration time',
      table5Text10: 'Level (wealth/charm/active)',
      table5Text11: 'Gold coins',
      table5Text12: 'Google/Apple top-up total',
      table5Text13: 'Banned to',
      table5Text14: 'Permanently ban',
      table5Text15: 'Register IP',
      table5Text16: 'country',
      table5Text17: 'Cumulative refund amount',
      table5Text18: 'Freeze',
      table5Text19: 'Not frozen',
      table5Text20: 'Is it frozen',
      table5Text21: 'Recharge time',
      table5Text22: 'Google takes the scan time as the standard, and Apple takes the notification time as the standard',

      table6Text1: 'Frozen account',
      table6Text2: 'Number of frozen gold coins (US dollars)',
      table6Text3: 'Nickname',
      table6Text4: 'Country',
      table6Text5: 'Recent refund amount',
      table6Text6: 'Registered IP',
      table6Text7: 'Level (Wealth/Charm/Active)',
      table6Text8: 'Account gold coin balance',
      table6Text9: 'Total recharge',
      table6Text10: 'Freeze time',
      table6Text11: 'Order Number',
      table6Text12: 'Registration time',
      table6Text13: 'Freeze operator',
      table6Text14: 'Freeze details',
      table6Text16: 'Freeze time',

      table6Text17: 'Modify the remark',
      table6Text18:'Reimbursement channels',
      table6Text19:'Payment order',
      table6Text20:'Number of gold COINS',
      table6Text21:'Minus gold',
      table6Text15: 'Last warning time',


    },
    giftList:{
      startEndTime:'The end time must be longer than the start time'
    },
    public: {
      quickReview:'A quick review',
      reviewTxt:'Total audit entries:{total},pass:{pass},reset data:{Refused}',
      attention: 'The ticked is reset data, the unticked is passed',
      reviewTxt_1:'Total audit entries:{total},pass:{pass},delete:{Refused}',
      attention_1: 'The ticked is delete, the unticked is passed',
      operatSuccess: 'Operation Succeed',
      operatError: 'Operation Failed',
      pass: 'Pass',
      refuse: 'Refuse',
      passed: 'Passed',
      noPass: 'Fail',
      refused: 'Refused',
      close: 'Close',
      submit: 'Submit',
      yes: 'Yes',
      no: 'No',
      sure: 'confirm',
      cancel: 'cancel',
      prompt: 'Prompt',
      operation: 'Operation',
      add: 'Add',
      delete: 'Delete',
      edit: 'Edit',
      query: 'Search',
      update: 'Modify',
      turkish: 'Turkish',
      arabic: 'Arabic',
      indonesian: 'Indonesian',
      en: 'English',
      vietnam: 'Vietnam',
      thailand: 'Thailand',
      india: 'Indy',
      spanish: 'Spanish',
      portugal: 'Portugal',
      all: 'All',
      noPermission: 'No permission',
      pleaseChoose: 'please choose',
      choose: 'select',

      none: 'Empty',
      sex: 'Porn / Sex',
      curse: 'Insult',
      religion: 'Disrespect for Religion',
      terroristActivities: 'Terrorist Activities',
      violationOfLaw: 'Violation of Law',
      propaganda: 'Promote Other App',
      resetHeadImg: 'Reset Avatar',
      search: 'Search',

      confirmOpear: 'Confirm the operation',
      confirmDelete: 'Confirm delete operation',
      confirmReset: 'Confirm to perform reset data',
      confirmBanDev: 'Confirm execution of banned device',
      confirmBan: 'Confirm execution of ban operation',
      confirmIgnore: 'Confirm to perform inspection pass operation',
      confirmPass: 'Confirm execution of pass operation',
      confirmRefuse: 'Confirm rejection',
      confirmMute: 'Confirm the mute operation',
      confirmUnMute: 'Confirm execution of unmuting operation',
      confirmRecommend: 'Confirm the recommended action',
      confirmShenPost: 'Confirm to perform the shenPost operation',
      confirmShield: 'Confirm shield operation',
      confirmUpRack: 'Confirm on line operation',
      confirmDownRack: 'Confirm off line operation',
      confirmUnbanBoard: 'Confirm to perform the broadcast operation',
      confirmCancelScreen: 'Confirm to unblock',

      noneData: 'No data',
      operatSuccessUpdate: 'Operation successful, updating status',
      pleaseChooseTarget: 'Please select the target',
      chooseAll: 'select all',
      permanentBan: 'Permanent ban',
      toText: 'to',
      showBigImg: 'View Larger Image',
      export: 'Export',
      chooseTime: 'Please choose time',
      startTime: 'Starting Time',
      endTime: 'End Time',
      enterStartTime: 'Please enter the start time',
      enterEndTime: 'Please enter the end time',
      date: 'Date',
      ignoreText: 'Ignore',
      waitAudit: 'Pending review',
      batchDelete:'Batch delete',
      download_template:'Download template',

      null:'null',
      points:'points',
      currentPoint:'Current point',
      freeze:'freeze',
      unfreeze:'unfreeze',

      banGather: "Ban and summon",
      unbanGather: "Lift the ban and convene",
      sureUnBanGather: "Are you sure to call for lifting the ban？",
      sureBanGather: "Are you sure to ban the convoy？",

      allequipment: "Same device account",

      clear:'clear',
      chooseImg:'choose Image',

      warnDel:'Warn and reject',
      region:'region',

      to:'to',

      reportedPerson:'Reported person',
      reporter:'Reporter',
    },
    userInformation: {
      enterId: 'Please enter user ID',
      userId: 'User ID',
      invalidId: 'This ID is invalid.',
      noUser: 'The user was not found',
      //
      search: 'Search',
    },
    problems: {
      startTime: 'Starting Time',
      endTime: 'End Time',
      enterUserId: 'user ID',
      enterCSId: 'Customer ID',
      search: 'Search',
      export: 'Export',
      unanswered: 'Unanswered',
      answered: 'Answered',
      detail: 'Details',
      userId: 'User ID',
      CSId: 'Customer ID',
      status: 'Status',
      qsType: 'Question Type',
      userRate: 'User Rating',
      nickname: 'Username',
      processorID: 'Processor ID',
      qsDescript: 'Problem Description',
      language: 'Language',
      createTime: 'Creation Time',
      answerTime: 'Response Time',
      oneStar: '1 Star',
      twoStar: '2 Stars',
      threeStar: '3 Stars',
      fourStar: '4 Stars',
      fiveStar: '5 Stars',
      endMoreStar: 'End Time should be greater than Start Time',
      chooseTime: 'Please select the time',
      pleaseChoose: 'please choose',
      text1: 'Feedback statistics',
      text2: 'Customer service account Statistics',
      text3: 'Closed questions',
      text4: 'Reply to questions',
      text5: 'Close All',
      text6: 'Reply all',
      text7: 'Confirm the end of the selected feedback?',
      text8: 'Respond to people',
      text9: 'Recovery time',
      text10: 'Reply content',
      text11: 'Edit person',
      text12: 'Edit time',
      text13: 'Number of reuse↑↓',
      text14: 'Last used↑↓',
      text15:'Confirm to reply with current answer？',
      text16:'The knowledge base',
      text17:'Recently used',
    },
    activityReview: {
      examinaPassed: 'Review passed',
      examinaNotPassed: "Review didn't pass",
      sureOperat: 'Confirm Pass Operation?',
      sureRefuse: 'Confirm Refuse operation?',
      sureDelete: 'Confirm Delete Operation?',
      userId: 'User ID',
      roomLiangId: 'Room ID',
      enterRoomId: 'Please enter the room ID',
      userIdInvalid: 'This ID is invalid',
      unReview: 'Unreviewed',
      reviewed: 'Audited',
      chooseAll: 'Select All',
      text1:'Feedback statistics',
      text2:'Customer service account Statistics',
    },
    appealHall: {
      allIp: 'View All IP',
      hasAccount: 'There are {num} accounts',
      enterId: 'Please enter user ID',
      search: 'Search',
      userId: 'User ID',
      userIdInvalid: 'This ID is invalid.',
      tabText1: 'Appeal list',
      tabText2: 'List of appeals >=50',
      tabText3: '',
      frozenId: '',
    },
    moreUserUpList: {
      chooseAll: 'Select All',
      banAll: 'Ban All',
      banChooseUser: 'Ban Selected Users',
      choose: 'Select',
      sureBanAll: 'Ban them all ?',
      enterBanUser: 'Please select a users.',
      sureBanUser: 'Confirm to ban these users.',
      banTimeTo: 'Ban Time',
      permanentBan: 'Permanent ban',
      enterUserId: 'Please enter user ID',
      search: 'Search',
    },
    application: {
      enterUserId: 'Please enter user ID',
      userId: 'User ID',
      userIdInvalid: 'This ID is invalid.',
      surePassOperat: 'Confirm Pass Operation?',
      sureRefuseOperat: 'Confirm Refuse operation?',
      unReview: 'Unreviewed',
      reviewed: 'Audited',
      table1Text1: 'application time',
      table1Text2: 'ID',
      table1Text3: 'Avatar',
      table1Text4: 'Wealth Level / Recharge Medal',
      table1Text5: 'Exchange ID',
      table1Text6: 'Original ID',
      table1Text7: 'Redeem ID',

      originalId:'Original ID'
    },
    backgroundReview: {
      showBigImg: 'View Larger Image',
      refuseReason: 'Please fill in the yeason for rejection',
      moreRefuseReason: 'Please enter a reason for rejection, up to 500 Characters',
      error: 'Error',
      surePassOperat: 'Confirm Pass Operation?',
      // 新增补
      text: 'Refused',
      text3: 'Pass',

      unReview: 'Unreviewed',
      reviewed: 'Audited',
      chooseAll: 'select all',
      reviewTime: 'Review time',
      roomId: 'Room ID',
      roomLiangId: 'Room ID',
      enterRoomId: 'Please enter the room ID',
      rejectTime: 'Rejection time',
      passTime: 'Passing time',
      operatName: 'Operator',
      waitTime: 'Waiting time',
      applicationTime: 'Application time',

      text2:'Please select a room',
    },
    page401: {
      content: 'You do not have permission to browse this page.',
    },
    page404: {
      content: 'Oh ~~ Your Page Seems To Fly Away ~',
    },
    page500: {
      content: 'Oh ~~ Ghost Knows What The Server Has Experienced ~',
    },
    backBtnGroup: {
      backHome: 'Back To Home Page',
      backLast: 'Go Back To The Last Page',
    },
    //
    familyInfomation: {
      enterId: 'Please enter Guild ID / Patriarch id',
      search: 'Search',
      allMember: 'View Guild members',
      ban24: 'Ban 24 hours',
      ban72: 'Ban 72 hours',
      ban30D: 'Ban 30 days',
      permanentBan: 'Permanent ban',
      familyOrTeamId: 'Guild ID / Patriarch id',
      familyId: 'Guild ID',
      familyName: 'Guild Name',
      patriarchName: 'Guild owner ID',
      familyImg: 'Guild avatar',
      member: 'Member number',
      level: 'Guild Level',
      point: 'Family receives gold coins',
      wealthClass: 'Wealth lLevel',
      charmLevel: 'Charm Level',
      ratio: 'Ratio',
      familyIdS: 'Guild ID',
      teamId: 'Guild owner ID',
      fiveM: '5 minutes',
      oneH: '1 hour',
      twoH: '2 hours',
      twelveH: '12 hours',
      sureUnBan: 'Sure to unban',
      enterInvalid: 'This ID is invalid.',
      unSearch: 'The data was not found',
      sureDelete: 'Confirm Delete Operation?',
      disband: 'Disband',
    },
    familyDissolution: {
      familySearch: 'Guild Query',
      dissolution: 'Guild Dismiss Application',
      familyId: 'Guild ID',
      familyName: 'Guild Name',
      familyImg: 'Guild Avatar',
      ownerId: 'Guild Owner ID',
      nickname: 'Guild Owner Name',
      level: 'Guild Level',
      starLevel: 'Guild Grade',
      number: 'Member number',
      addTime: 'Application Time',
      dissolutioned: 'Dismissed',
      ignore: 'Ignore',
      ignored: 'Ignored',
      dissolutionFam: 'Dismiss the guild',
      checkDissolut: 'Confirm the execution of the dissolution of the family',
      checkIgnore: 'Confirm to ignore',
    },
    homeDetail: {
      familyInfo: 'Guild Information',
      familyId: 'Guild ID',
      familyName: 'Guild Name',
      familyImg: 'Guild Avatar:',
      chooseImg: 'Select Image',
      clear: 'Clear',
      declarat: 'Guild Declaration',
      isFamily: 'Whether it is a star Guild',
      ratio: 'Ratio',
      ratioValue: 'Percentage: Please enter a number between 0-100',
      level: 'Guild Level',
      strengthLevel: 'Wealth Level',
      charismaLevel: 'Charm Level',
      queryFail: 'Query Failed',
      nameNoNot: 'Please enter the guild name',
      resetInfo:'Reset data',
      sureResetInfo:'Sure reset the data?',
    },
    familyMember: {
      enterUserId: 'Please Enter Member ID',
      //
      search: 'Search',
      confidential: 'Confidential',
      male: 'Male',
      female: 'Female',
      userId: 'Member ID',
      familyId: 'Guild Member ID',
      nickname: 'Member Nickname',
      gender: 'Gender',
      headImg: 'Member Avatar',
      contributionToday: "Today's Contribution (Diamond)",
      contributionMonth: "Contribution of The Month (Diamond)",
      enterInvalid: 'This ID is invalid.',
      sureDelete: 'Sure to delete this guild member?',
      role:'role',

    },
    faqDate: {
      module: 'Module',
      chooseType: 'Please select a question type',
      language: 'Language',
      qs: 'Problem',
      answer: 'Reply',
      img: 'Image',
      sureUpdate: 'Confirm to edit',
      noneNotice: 'Question or answer cannot be empty',
      jumpLink: 'Jump link',
    },
    knowledgeList: {
      chooseType: 'Please select a question type',
      add: 'Add',
      prompt: 'Prompt',
      module: 'Module',
      sureDelete: 'Confirm Deletion?',
      sort: 'Sort',
      type: 'Types of',
      qs: 'Problem',
      answer: 'Reply',
      image: 'Image',
      time: 'Time',
      chooseImg: 'Select Image',
      clear: 'Clear',
      permanentBan: 'Permanent ban',
    },
    login: {
      title: 'Multi-National Customer Service Management System',
      loginWarn: 'Your account has been logged in elsewhere, it is recommended to change the password',
    },
    machineReport: {
      selectAll: 'select all',
      enterUserId: 'Please enter user ID',
      inTotal: 'There are {num} accounts',
      content: 'Report content:',
      image: 'Report images:',
      userId: 'User ID',
      enterIdInvalid: 'This ID is invalid.',
      banUser: 'Block Users Successfully',
      ignore: 'Confirm to ignore report information?',
      tabText1: 'Machine report record',
      tabText2: 'Ban record',
      ignored: 'Checked',
      reseted: 'Information reset',
      banDeviced: 'Ban devices',
      banIdTo: 'ban ID',
      resetData: 'Reset data',
      banId: 'ban ID',
      banDevice: 'Ban equipment',
      ignore: 'Inspection passed',
    },
    problemsDetail: {
      userId: 'User ID',
      nickname: 'Username',
      customerID: 'Customer ID',
      customerNickname: 'Customer Service Nickname',
      qs: 'Problem',
      language: 'Language',
      qsImg: 'Question Picture',
      prompt: 'Sorry! Your browser does not support video tags',
      type: 'Types',
      answer: 'Reply',
      answerImg: 'Reply the image',
      status: 'Status',
      rate: 'Rate',
      unanswered: 'Unanswered',
      answered: 'Answered',
      orderNum: 'Order Number',
      chooseMediaText: 'Choose up to five pictures or one video to upload',
      mostImgText: 'Upload up to five pictures',
      mostVideoText: 'Upload at most one video',
      text: 'Select quick Reply',
      text1: 'Send a reply',
      text2: 'The reply cannot be empty！',
      text3: 'Close the question after replying',

      inTotal:'{num} accounts',
    },
    roomManagement: {
      enterRoomId: 'Please enter the room ID',
      roomId: 'Room ID',
      enterIdInvalid: 'This ID is invalid.',
      notFoundRoom: 'The Room was not found',
      ban24: 'Ban 24 hours',
      ban72: 'Ban 72 hours',
      ban30D: 'Ban 30 days',
      permanentBan: 'Permanent ban',
      tabText1: 'Room query',
      tabText2: '',
    },
    auditManageDisband: {
      roomId: 'Room ID',
      roomName: 'Room name',
      roomImg: 'Room avatar',
      owerId: 'Room Owner ID',
      nickname: 'Room Owner Name',
      level: 'Room Level',
      hot: 'Room Visitor',
      currentMonth: 'This Month Trophy',
      application: 'Application Time',
      roomLiangId: 'Room ID',
      ignore: 'Ignore',
      dismiss: 'Dismiss the room',
      checkIgnore: 'Confirm to ignore',
      checkDismiss: 'Confirm to dismiss',
      deleted: 'Disbanded',
      ignored: 'Ignored',
      cost:'Room Trophy',
      hmeownerId: '',
      recoverRoom: '',
      confirmRecovery: '',
      confirmRecoveryTitle: '',
      roomCostMoney: '',
      disbandTime: '',
    },
    roomDetail: {
      title: 'Title',
      content: 'Content',
      roomId: 'Room ID',
      ban: 'Ban',
      roomName: 'Room Name',
      roomImg: 'Room Avatar:',
      bg: 'Room theme:',
      expirationDate: 'Expiration Date',
      tags: 'Label',
      level: 'Room Level',
      roomOwnerId: 'Roomowner id',
      updateNickname: 'Modify Room Nickname',
      nicknameUnNone: 'Please enter the nickname',
      //
      sureBanRoom: 'Confirm to ban the room',
      sureUnbanRoom: 'Confirm to unblock the room',
      liftTheBan: 'Lift the ban',
      chooseTime: 'Choose ban time',
      permanentBan: 'Permanent Ban',
      roomBlacklist: 'Room blacklist',
      userId: 'User ID',
      userNickname: 'User Nickname',
      deleteUser: 'Remove',
      checkDeleteUser: 'Are you sure you want to remove the user {username} from the blacklist?',
      editRoomNumT: 'Original room number: {roomNum}',
      editRoomId: 'Modify the room number',
      roomIdNotNull: 'Room number cannot be empty',
      roomIdIsNum: 'The room number should be a number',
      resetRoomInfo: 'Reset room information',
      resetRoomWarn: 'Confirm to perform the reset room information operation',
      userLv: 'User level (wealth/Glamour/Activity)',
    },
    serviceManagement: {
      add: 'Add',
      info: 'Customer Service Information',
      customerID: 'Customer ID',
      enterCustomerID: 'Please enter Customer Service ID',
      language: 'Language',
      prompt: 'Prompt',
      sureDelete: 'Confirm To Delete?',
      today: 'Number of replies today',
      week: 'Number of replies week',
      weekRate: '7-Day Rating',
      rateNum: 'Number of Ratings',
      enterLanguage: 'Please select language',
      text1:'The ID of the service',
      text2:'Customer Service Account Name',

      nickname:'nickname',
      country:'country',
      loginTime:'Last login time',
    },
    user_data: {
      freezeMoney: 'Freeze consumption',
      unFreezeMoney: 'Unfreeze',
      sureFreeze: 'Are you sure to freeze consumption?',
      sureUnFreeze: 'Sure to unfreeze',
      title: 'Title',
      content: 'Content',
      number: 'ID',
      addItem: 'Add Items',
      add: 'Add',
      setItem: 'Item Settings',
      endItem: 'End of Item',
      headImg: 'Avatar',
      chooseImg: 'Select Image',
      clear: 'Clear',
      nickname: 'Username',
      gender: 'Gender',
      male: 'Male',
      confidential: 'Confidential',
      female: 'Female',
      birthday: 'Date of Birth',
      phone: 'Cell Phone',
      email: 'Mailbox',
      country: 'Country',
      province: "Province",
      hobby: 'Hobby',
      tag: 'Label',
      sign: 'Signature',
      familyName: 'Guild Name',
      rechargeAmount: 'Recharge Amount (Yuan)',
      agentRecharge: 'Agency Recharge (Usd)',
      contribution: 'Contribution Value (Gold Coins)',
      charmValue: 'Charm Value (Gold Coins)',
      goldCoin: 'Gold Coin Balance',
      diamond: 'Diamond Balance',
      exchange: 'Total Number of Diamonds Exchanged for Diamonds',
      registerTime: 'Registration Time',
      registerIp: 'Register IP',
      equipment: 'Equipment',
      equipmentText: 'Has been banned, blocked account',
      moreIp: 'More IP',
      lastLoginTime: 'Last Login',
      monthEarnings: "This Month's Rewards",
      lastMonthEarnings: "Last Month's Rewards",
      createRoomId: 'Room ID',
      banId: 'Ban ID',
      unBanId: 'Un Ban ID',
      banTimeTo: 'The Ban is Up To:',
      permanentBan: 'Permanent Ban',
      ban: 'Ban',
      liftTheBan: 'Unbanned',
      banEquipment: 'Ban Equipment',
      unBanEquipment: 'Un Ban Equipment',
      muteText: 'Mute',
      unMuteText: 'Unmute',
      checkMute: 'Confirm the mute operation?',
      checkUnMute: 'Confirm execution of unmute operation?',
      banCount: 'Banned',
      times: '{counts} times',
      freezeConsumption: 'Freeze Consumption',
      freezeing: 'Freezing',
      normal: 'Normal',
      inMai: 'on-mic Time',
      wealthClass: 'Wealth lLevel',
      charmLevel: 'Charm Level',
      activeLevel: 'Active Level',
      banReason: 'Reasons for Ban',
      itemType: 'Item Type',
      items: 'Items',
      aging: 'Validity(Days)',
      numOrDate: 'Quantity or effective duration (days)',
      numText: 'Quantity',
      dateText: 'vip days',
      updateNum: 'Modify ID',
      numberId: 'User ID',
      updateNickname: 'Change Username',
      nickname: 'Username',
      detailList: 'List of Details',
      ban24: 'Ban for 24 Hours',
      ban72: 'Ban for 72 Hours',
      ban7D: 'Ban for 72 Hours',
      ban30D: 'Banned for 7 days',
      ban90D: 'Banned for 90 days',
      vehicle: 'Mount',
      medal: 'Medal',
      headdress: 'Headwear',
      number: 'User ID',
      VIP: 'Aristocracy',
      hasAccount: 'There are {num} accounts',
      authentication: 'Authentication',
      day: 'day',
      // 补
      gift: 'Gift',
      coupon: 'Coupon',
      roomMedal: 'Room Medal',
      sureUpdateImg: 'Sure to change the avatar?',
      sureDeleteItem: 'Sure to delete this item?',
      enterIdInvalid: 'This ID is invalid.',
      enterNoNone: 'Please enter the nickname',
      enterReason: 'Please fill in the reason for banning',
      sureBanId: 'Sure to ban this ID?',
      sureUnBanId: 'Sure to unban this ID?',
      sureBanDevice: 'Sure to ban this device?',
      sureUnBanDevice: 'Sure to unban this device?',
      //
      setTtem: 'Set props',
      roomDetail: 'Room details',
      showItem: 'View props',
      itemDetail: 'Prop details',

      unBanBoard: 'Unban broadcast',
      checkEditCountry: 'Confirm to modify country?',
      showCp: 'View special cp relationship',
      otherId: 'The other side',
      typeText: 'Types of',
      teamTime: 'Composition relationship time',
      cpDetail: 'Special cp relationship',
      level: 'grade',
      point: 'integral',
      roomText: 'room',

      table2Text1: 'frequency',
      table2Text2: 'Block type',
      table2Text3: 'Reason for ban',
      table2Text4: 'Block time',
      table2Text5: 'operating system',
      table2Text6: 'Operating time',
      table2Text7: 'Operation role',
      table2Text8: 'operator',
      showDetail: 'See details',
      banHistoryTitle: 'Past history of banned personnel',
      roleText1: 'Backstage',
      roleText2: 'Supertube',
      roleText3: 'State Administration',
      passwordText: 'Password',
      updatePassword: 'Change Password',
      warnPassword: 'Password can not be blank',
      warnPassword2: 'Confirm to execute the password modification operation',
      updatePhone: 'Modify mobile phone number',
      warnPhone: 'The entered mobile phone number cannot be empty',
      warnPhone2: 'Confirm to perform the operation of modifying the mobile phone number',
      updateMail: 'Modify email',
      warnMail: 'The email address entered cannot be empty',
      warnMail2: 'Confirm to perform the modify mailbox operation',
      bandOpt1: 'Unbind QQ',
      bandOpt2: 'Unbind WeChat',
      bandOpt3: 'Unbind Facebook',
      bandOpt4: 'Unbind Google',
      bandOpt5: 'Dismiss snapchat',
      warnBind: 'Confirm execution of unbinding operation',
      unBindText: 'Unbind',
      unBindText2: 'Unbind',
      resetUser: 'Reset personal information',
      warnResetUser: 'Confirm the resetting of personal information',
      warnBtnText: 'Caveat',
      warnMarkText1: 'Warning content',
      warnMarkText2: 'Reason for warning',
      warnMarkText3: 'Image',
      warnMarkText4: 'All input information cannot be empty',
      text1:'Delete all comments',
      text2:'Confirm that the user deletes all comments?',
      text3:'Delete all posts',
      text4:'Confirm that the user has deleted all posts？',
      text5:'Individual floating screen',
      text6:'Chat bubble',

      phoneRegion:'Binding area code',
      labelTxt34: "Change the binding number",


      points:'point',
      currentPoint:'Current points',
      freeze:'frozen',
      unfreeze:'unfreeze',
      donTime: "Freeze expiration time",
      donWhy: "Reason for freezing",

      banGather: "Ban and summon",
      unbanGather: "Lift the ban and convene",
      sureUnBanGather: "Confirm the convening of lifting the ban？",
      sureBanGather: "Are you sure to ban the convoy？",

      allequipment: "Same as equipment account number",

      userlevel:'User level (wealth / Charm / activity)',
      recharge_money:'Total recharge',
      credit1:'Gold coin balance',
      credit2:'Diamond balance',

      memorandum: "Operational notes",
      addMemo: "Add a note",
      enterMemoContent: "Please enter the memo...",

      svipFreezeTitleText:'Recent operation records',
      deTime: "Operation time",
      deman: "Operator",
      freezePoint:'Freezing points',
      type: "Operation type",

      banTime: "Expiration time of ban",
      banWhy: "Reasons for ban",
      receban:'Recent blocking records',

      userLevel:'Level(wealth/charm/active/SVIP)',
      changeGender:'Modify gender',
      chooseGender:"Choose gender",
      changeCountry:'Modify country and province',
      reason:'reason',

      target:'Target',
    },
    ip_detail: {
      enterUserId: 'Please enter user ID',
      // 补
      userId: 'userId',
      loginTime: 'Registration',
      loginUser: 'Registered user',
      loginIp: 'Register ip',
      lastLoginTime: 'last login time',

      nickname: 'Nickname',
      deviceCode: 'Device Code',
      country: 'Country',
      wealth: 'Wealth',
      charm: 'Charm',
      activeLevel: 'Active Level',
      banAll: 'Ban All',
      banAll_1: 'Ban all ≤ LV5',
      banChooseUser: 'Ban Selected Users',
      levelText: 'Level',
      refreshList: 'refresh the list',
      resetData: 'Reset profile',
      checkResetData: 'Confirm to perform data reset operation',
      checkResetData1: 'Confirm the repayment operation?',

      unBanDevice:'Lifting equipment',
    },
    userReport: {
      warning: 'warning',
      search: 'Search',
      banTimeTo: 'Ban Time',
      detail: 'Details',
      appQs: 'App issues',
      suggest: 'Suggest',
      topUp: 'Recharge',
      sex: 'Porn',
      harassment: 'Harassment',
      spam: 'Spam',
      violationOfLaw: 'illegal',
      other: 'Other',
      sureBanUser: 'Sure to unban this user?',
      ignore: 'Confirm to ignore report information?',
      sureDelete: 'Sure to delete?',
      unBanSuccess: 'Unbanned Successfully',
      banSuccess: 'Banned Successfully',
      permanentBan: 'Permanent Ban',
      // 新增补
      tabText1: 'User report list',
      tabText2: 'Violation record',
      tabText3: 'Ignore record',
      resetData: 'Reset data',
      banId: 'ban ID',
      banDevice: 'Ban equipment',
      ignore: 'Inspection passed',
      chooseAll: 'select all',
      ignored: 'Checked',
      reseted: 'Information reset',
      banDeviced: 'Ban devices',
      banIdTo: 'ban ID',
      banRoomTo: 'Ban the room',
      level: 'Level',
      registerIp: 'Register ip',
      inTotal: 'There are {num} accounts',
      selectAll: 'select all',
      topUpReport: 'Top-up report',
      text: 'Please enter the reported user/host id'
    },

    //
    account: {
      addAccount: 'Add administrator account',
      edit: 'Edit',
      ban: 'Disable',
      unBan: 'Unban',
      addTo: 'On list',
      unAddTo: 'Off the shelf',
      accountId: 'Administrator ID',
      username: 'Username',
      realname: 'Real name',
      role: 'Roles',

      lastLoginTime: 'Last Login Time',
      fiveM: '5 minutes',
      oneH: '1 hour',
      twoH: '2 hours',
      twelveH: '12 hours',
      sureDelete: 'Sure to delete?',
      sureBanAccount: 'Sure to ban this account',
      sureUnBanAccount: 'Sure to unban this account',
    },
    //
    windDetail: {
      setAccount: 'Account Settings',
      username: 'Username',
      newPassword: 'New Password',
      checkPassword: 'Confirm Password',
      realname: 'Real name',
      role: 'Roles',
    },
    //
    authorityManagement: {
      addRole: 'Add role',
      editRole: 'Edit role',
      editAuthority: 'Edit permissions',
      roleInfo: 'Role information',
      sort: 'Serial number',
      roleName: 'Role',
      authority: 'Permission editing',
      role: 'Roles',
      text7:'Authorization list',

      text1:'Module permission Management',
      text2:'The module',
      text3:'Operation name',
      text4:'Whether to enable',
      text5:'Module permission Setting',
      tabText2: 'Big R recharge data tracking',
      text6:'Item distribution restriction list',
      page6Text1:'Total amount of gold allowed for gift this month',
      page6Text2:'The number of non-gift distributions allowed this month',
      page6Text3:'Creation time',
      page6Text4:'Modify the time',
    },
    //
    menuagement: {
      add: 'Add',
      editAuthority: 'Modify permissions',
      menuName: 'Menu',
      name: 'Name',
      back: 'Return',
      authorityName: 'Function',
      sureDeleteMenu: 'Sure to delete this menu',
      sureDeleteAuthority: 'Confirm to delete the permission',
    },
    // 补
    superTube: {
      enterIdOrKeyword: 'Please enter id',
      userId: 'Id',
      headImg: 'Avatar',
      nickname: 'Nickname',
      country: 'Country',
      lastLoginTime: 'Last Login Time',
      adminList: 'Administrator list',
      adminGroup: 'Administrator group',
      addGroup: 'New group',
      editGroup: 'Edit group',
      groupId: 'Group id',
      groupName: 'group name',
      remarks: 'Remarks',
      createTime: 'Creation time',
      updateTime: 'Update time',
      comfirmDeleteGroup: 'Are you sure to delete the group?',
      grouping: 'Grouping',
      updateGroup: 'Modify group',
      teamNameNoNull: 'Group name cannot be empty',
    },
    national: {
      idOrName: 'ID',
      enterIdOrKeyword: 'Please enter id',
      userId: 'Id',
      headImg: 'Avatar',
      nickname: 'Nickname',
      country: 'Country',
      lastLoginTime: 'Last Login Time',
    },
    lostOrder: {
      startTime: 'Starting time',
      endTime: 'End Time',
      dataType: 'Type of data',
      orderIdOrUserId: 'Lost bill number / user ID',
      topUp: 'Top up',
      gold: 'Gold',
      date: 'Date',
      userId: 'User ID',
      nickname: 'Nickname',
      amountReceived: 'Amount received',
      agentRecharge: 'Agency Recharge (Usd)',
      text1:'The total number of feedback',
      text2:'Reply to a few',
      text3:'Background Replies',
      text4:'Number of replies in App',
      text5:'App problem',
      text6:'Prepaid phone problem',
      text7:'advice',
      text8:'other',
      text9:'Total users',
    },
    questionStatistics:{
      text1:'total number of questions',
      text2:'Number of users who received replies',
      text3:'total replies',
      text4:'Background replies',
      text5:'In-app replies',
      text6:'Number of App Questions',
      text7:'Number of recharge questions',
      text8:'number of suggested questions',
      text9:'Number of other questions',
    },
    questionBank: {
      addQs: 'Add question',
      sureDelete: 'Confirm Deletion?',
      uploadVideoError: 'The duration of the uploaded video cannot exceed 30s',
      importExcel:'Import knowledge base',
      ChineseRemarks:'Chinese describe',
      btnText:'Video or picture URL',
      uploadSuccess:'Upload successful',
    },
    communityLanguage: {
      language1: 'English',
      language2: 'Arabic',
      language3: 'Indonesian',
      language4: 'Turkish',
      language5: 'Hindi',
      language6: 'Vietnamese',
      language7: 'Thai',
      language8: 'Brazil',
      language9: 'Spanish',
      language10: 'Gulf group',
      language11: 'Indonesian',
      language12: 'Portugal',
      language1Area: 'English area',
      language2Area: 'Arabic',
      language3Area: 'Indonesian area',
      language4Area: 'Turkish speaking area',
      language5Area: 'Hindi area',
      language6Area: 'Vietnamese area',
      language7Area: 'Thai area',
      language8Area: 'Brazil',
      language9Area: 'Spanish area',
      language10Area: 'Indonesian area',
      language11Area: 'Portuguese area',
      language12Area: 'Bay area',
    },
    // 暂时不用
    communityLanguage2: {
      language1: 'English',
      language2: 'Arabic',
      language3: 'Indonesian',
      language4: 'Turkish',
      language5: 'Hindi',
      language6: 'Vietnamese',
      language7: 'Thai',
      language8: 'Brazil',
      language9: 'Spanish',
      language10: 'Gulf group',
      language11: 'Indonesian',
      language12: 'Portugal',
      language1Area: 'English area',
      language2Area: 'Arabic',
      language3Area: 'Indonesian area',
      language4Area: 'Turkish speaking area',
      language5Area: 'Hindi area',
      language6Area: 'Vietnamese area',
      language7Area: 'Thai area',
      language8Area: 'Brazil',
      language9Area: 'Spanish area',
      language10Area: 'Indonesian area',
      language11Area: 'Portuguese area',
      language12Area: 'Bay area',
    },
    topicManagement: {
      addTopic: 'Recommended topic',
      // tabText1: 'Non-Turkish',
      // tabText2: 'Turkish Zone',
      tabText1: 'English language',
      tabText2: 'Arabic',
      tabText3: 'Indonesian',
      tabText4: 'Turkish',
      table1: 'Sort',
      table2: 'Topic',
      table3: 'Topic avatar',
      table4: 'Topic introduction',
      table5: 'Creation time',
      table10: 'Recommended end time',
      table6: 'Posts',
      table7: 'Comments',
      table8: 'Likes',
      table9: 'status',
      table11: 'Current topic manager',
      opera1: 'Off line',
      opera2: 'On line',
      topicName: 'Topic',
      topPlaceholder: 'Please enter a topic name',
      topicImg: 'Topic picture',
      chooseImg: 'Select Image',
      topicDesc: 'Topic description',
      topicSort: 'Sort',
      topicUp: 'Area',
      languageAr: 'Arabic',
      languageEn: 'English Zone',
      languageY: 'Indonesia Zone',
      languageTr: 'Turkish',
      sortNeetNum: 'Topics should be formatted as numbers',
      titleNotNull: 'Topic name cannot be empty',
      imageNotNull: 'Topic picture cannot be empty',
      introduceNotNull: 'Topic description cannot be empty',
      regionNotNull: 'Upload area cannot be empty',
      recommendTimeTo: 'Recommend to',
      chooseYMD: 'Please select year, month and day',
      chooseHMS: 'Please select hours, minutes and seconds',

      topicId: 'Topic id',
      topicMarkTitle: 'Language area: {area}, topic name: {name}',
      languageArea: 'Language area',
      userId: 'User ID',
      userName: 'user name',
      topicId: 'Post id',
      postContente: 'post content',
      pic: 'image',
      audio: 'Audio',
      operatUser: 'Operation user',
      movePost: 'Transfer',
      postMoveTopic: 'Post transfer to other topics',
      topicText: 'Topic',
      enterWarnCode: 'Please fill in the complete passcode',
      enterTopicCode: 'Please select topic',
      selectMove: 'Transfer selected posts',
      pleaseSelectPost: 'Please select the post to be operated first',
      isOfficial: 'Is it an official topic',
      warnNum: 'The value cannot be greater than 9999999999',
      editAdmin: 'Edit manager',
      addAdminId: 'Add administrator id',
      nowTopicAdmin: 'Current topic manager',
      topicAdmin: 'Topic manager',
      addTopicWarn: 'Confirm to add the user as a topic manager?',
      deleteTopicWarn: 'Confirm to delete the topic manager?',
      editTopicType: 'Edit topic categories',
      setTopic: 'Set topic classification',
      editTopic: 'Edit topic category',
      addTypeTitle: 'Add topic category',
      editTypeTitle: 'Edit topic category',
      addTypeForm1: 'Add region',
      addTypeForm2: 'Add topic category',
      addTypeForm3: 'Edit topic category',
      typeListTitle: 'The current locale is: ',
      table2Text1: 'Sort',
      table2Text2: 'Topic category',
      table2Text3: 'Language area',
      table2Text4: 'status',
      statusWarnText1: 'Confirm to perform the listing operation',
      statusWarnText2: 'Confirm execution of the delisting operation',
      addTypeForm4: 'Add topic category name',
      addTypeForm5: 'Topic category sort',
      statusWarnText3: 'Topic category can not be empty',
      statusWarnText4: 'Confirm to add this topic category',
      statusWarnText5: 'Confirm to modify the topic category',
      statusWarnText6: 'Topic category name cannot exceed 120 characters',
      placeholder1: 'Please enter the topic name',
      topicName1: 'Topic category name (English)',
      topicName2: 'Topic category name (Arabic)',
      topicName3: 'Topic category name (Hindi)',
      topicName4: 'Topic category name (Turkey)',
      topicName5: 'Topic category name (Spain)',
      topicName6: 'Topic category name (Vietnam)',
      selectWarn1: 'Please select the online area',
    },
    topicReview: {
      search1: 'Partition',
      search2: 'Category',
      search3: 'User id',
      search4: 'Pending review',
      search5: 'Refuse',
      search5_1: 'Deleted',
      search6: 'Status',
      tab1: 'Unreviewed',
      tab2: 'reviewed',
      tableText1: 'Language Area',
      tableText2: 'topic classification',
      tableText3: 'User id',
      tableText4: 'User Name',
      tableText5: 'topic name',
      tableText6: 'Topic Introduction',
      tableText7: 'topic picture',
      tableText8: 'application time',
      tableText9: 'Operator',
      tableText10: 'Operation time',
      tableText11: 'The user countries',
      tableText12: 'Batch delete',
      tableText13: 'Batch through',
      tableText16: 'Batch refuse',
      tableText14: 'Community gag & denial',
      tableText15: 'Block ID & reject',
      warnText1: 'Confirm the execution of the pass operation',
      warnText2: 'Confirm rejection operation',

      btnText1:'Refuse after warning',
      btnText2:'ban square',
    },
    postPermiss: {
      checkAdmin: 'Whether to verify the super tube',
      checkNoble: 'Whether to verify nobility',
      checkLevel: 'Any level >=',
      levelWarn: 'Level needs to fill in numbers',
    },
    contentReview: {
      chooseLanguage: 'Please select a language area',
      choosePost: 'Please select post status (default is empty)',
      chooseUserId: 'Please enter user ID',
      languageArea: 'Language Zone',
      languageAr: 'Arabic',
      languageEn: 'English Zone',
      languageY: 'Indonesia Zone',
      languageTr: 'Turkish',
      userId: 'User ID',
      nickname: 'user name',
      topicName: 'Topic',
      postContent: 'post content',
      votingOptionsContent: 'Voting Options Content',
      topicImg: 'image',
      audio: 'Audio',
      createTime: 'Creation time',
      commentAndGood: 'Number of comments/Likes',
      commentsNum: 'Number of comments',
      goodNum: 'Likes',
      operaUser: 'Operating user',
      recommend: 'recommend',
      shield: 'shield',
      search: 'search for',
      wait: 'Pending review',
      process: 'examination passed',
      notPassed: 'Audit not passed',
      pleaseChoose: 'please choose',
      unrecommend: 'Not recommended',
      shenPost: 'not recommend',
      shenPosted: 'not recommended',
      unshield: 'Unblock',
      recommended: 'Recommended',
      systemRecome: 'System recommendation',
      shielded: 'Blocked',
      cancalShielded: 'Unblock',
      deleted: 'deleted',
      postId: 'Post id',
      seeType: 'Visible type',
      visibleToAll: 'visible to all',
      followSee: 'Follow to see',
      mutualVisible: 'Mutual attention visible',
      private: 'Private, visible only to the owner',
      topText: 'Top',
      chooseTopTime: 'Choose the top time',
      pleaseChooseTime: 'Please choose time',
      pleaseEnterTime: 'Please enter the top time',
      topTimeTo: 'Top to {time}',
      checkCancelTop: 'Confirm unpinning',
      privatePost: 'Private posts cannot be edited',
    },
    // 年度盛典
    annualCeremony: {
      postId: 'Post ID',
      topicId: 'Topic ID',
      topicTitle: 'Topic Name',
      topicContent: 'Post content',
      topicImg: 'Post picture',
      topicVoice: 'Voice',
      seconds: 'Number of seconds',
      sort: 'sort',
      create_time: 'Add time',
      addPost: 'Add Featured',
      sortText: 'The larger the number, the more front',
      topicNotNull: 'The post id needs to be a number and cannot be empty',
      sortNotNull: 'The sorting needs to be numeric and cannot be empty',
      editPost: 'Editor\'s Choice',
      checkDelPost: 'Confirm to delete this featured post',
    },
    reportManagement: {
      postReport: 'Post report',
      commentReport: 'Comment report',
      fuseList: 'Comment circuit breaker list',
      postFuseList: 'post fuse list',
      pleaseChoose: 'Please select a language area',
      pleaseUserId: 'Please enter user ID',
      languageArea: 'Language Zone',
      languageAr: 'Arabic',
      languageEn: 'English Zone',
      languageY: 'Indonesia Zone',
      languageTr: 'Turkish',
      userId: 'User ID',
      username: 'user name',
      topicName: 'Topic',
      postContent: 'post content',
      commentContent: 'comments',
      image: 'image',
      audio: 'Audio',
      reportTime: 'Earliest report time',
      reportNum: 'Reports',
      reporterId: 'Reporter',
      status: 'status',
      operater: 'operator',
      ignore: 'Inspection passed',
      shield: 'shield',
      cancelShield: 'Unblock',
      ignored: 'Checked',
      shielded: 'Blocked',
      deleted: 'Deleted',
      mute: 'Mute',
      muted: 'Muted',
      unMute: 'Unmute. Mute expiration time: {date}',
      operatRole: 'Operator role',
      role1: 'Auditors',
      role2: 'Super Admin',
      role3: 'Background administrator',
      role4: 'Country administrator',
      showBigImg: 'View Larger Image',
      operatTime: 'Operating time',
      checkCancelShield: 'Confirm to unblock',

      deleteAndBan:'Delete and forbid',
      deleteAndBanId:'Delete and forbidden ID',
      batchDelete:'Batch delete',
      batchIgnore:'Batch ignore',
      pleaseChooseContent:'Please select content',
      sureAction:'Are you sure to {action} the selected content',
    },
    auditorManagement: {
      auditStatistics: 'Audit statistics',
      auditMemberManage: 'Auditor management',
      auditId: 'Auditor ID',
      yesterdayAudit: 'Number of audits yesterday',
      weekAuditNum: 'Number of review（this week）',
      lastWeekAuditNum: 'Number of review（last week）',
      monthAuditNum: 'Number of review（this month）',
      lastMonthAuditNum: 'Number of review（last month）',
      addAuditId: 'Add reviewer id',
      forLanguageArea: 'Responsible language area',
      languageAr: 'Arabic',
      languageEn: 'English Zone',
      languageY: 'Indonesian',
      languageTr: 'Turkish',
      auditMem: 'Auditors',
      languageArea: 'Language Zone',
      enterAuditId: 'Please enter the reviewer ID',
      chooseLanguage: 'Please select service language (multiple choices)',
      auditModalTitle: 'Auditor management',
      userIdNotNull: 'Auditor id cannot be empty',
      enterUserId: 'Please enter user ID',
      userId: 'User ID',
      region: 'Area',
      text1:'Audit number of yesterday',
      text2:'Number of audits this week',
      text3:'Number of audits last week',
      text4:'Monthly audit',
      text5:'Last month audit',
      text6:'',
    },
    communityAnomaly: {
      resetData: 'Reset data',
      banId: 'ban ID',
      banDevice: 'Ban equipment',
      ignore: 'Inspection passed',
      enterUserId: 'Please enter user ID',
      mute: 'Mute',
      muted: 'Muted',
      unMute: 'Unmute',
      tabText1: 'Community anomaly records',
      tabText2: 'Ban record',
      enterIdInvalid: 'This ID is invalid.',
      userId: 'User ID',
      inTotal: 'There are {num} accounts',
      ignoreText: 'Confirm to ignore report information?',
      userIdText: 'User ID',
      oneMinComment: 'Comments in 1 minute',
      userLevel: 'user level',
      registerTime: 'Registration time',
      registerIp: 'Register ip',
      country: 'Country',
      clickShowText: 'Click to view',
      operatTime: 'Operating time',
      operatContent: 'Operation content',
      operaUser: 'Operator',
      ignored: 'Checked',
      ban12hed: 'Broadcast blocked 12h',
      banDeviced: 'Banned devices',
      banIded: 'Banned id',
      reseted: 'Information reset',
      contentList: 'Reply content list',
      contentDelAll: 'delete all',
      replyContent: 'Reply content',
      choose: 'Select',
      delSelect: 'Delete selected reply',
      delSelectCheck: 'Confirm to delete the selected reply',
      deleted: 'deleted',
      status: 'status',
      muteAlreadyOut: 'The ban has been lifted',
      muteTime: 'Mute expiration time',
    },
    statistics: {
      contentStatistics: 'Community content statistics',
      userStatistics: 'Community user behavior statistics',
      interactivePosts: 'Community Interactive Post Statistics',
      date: 'date',
      postedNum: 'Number of posts posted',
      interactiveNum: 'Number of interactive posts',
      likesNum: 'Number of Likes',
      commentsNum: 'Number of commented posts',
      sharedNum: 'Number of shared posts',
      topicNum: 'Number of topical posts',
      hasVoiceNum: 'Number of voice posts',
      hotPostNum: 'Number of popular posts',
      //  社区用户行为统计
      activeUser: 'Square active users',
      userPostNum: 'Number of users posting posts',
      joinLinkNum: 'Number of users participating in likes',
      userCommentNum: 'Number of users participating in comments',
      userLinkNum: 'User likes',
      userShareNum: 'User reviews',
      userShare: 'User shares',
      region: 'area',
      allData: 'Summary',
      // 社区互动帖子统计
      oneDay: 'first day',
      twoDay: 'the next day',
      threeDay: 'Third day',
      fourDay: 'Fourth day',
      fiveDay: 'Fifth day',
      sixDay: 'Sixth day',
      sevenDay: 'The seventh day',
      startGtEnd: 'The start time cannot be greater than the end time',
      numberOfPosts: 'Number of posts with votes',
      numberOfUsers: 'Number of users participating in voting',
    },
    broadcastManagement: {
      enterId: 'Please enter user ID',
      userLiangId: 'User ID',
      areaSearch: 'Search by area',
      tabText1: 'Audited',
      tabText2: 'Unreviewed',
      ignore: 'Inspection passed',
      ban12h: 'Ban broadcast 12h',
      banBtn: 'Ban broadcast',
      banDevice: 'Ban equipment',
      banId: 'Ban ID',
      selectAll: 'select all',
      choose: 'Select',
      country: 'country',
      userId: 'User ID',
      username: "User's Nickname",
      broadcastContent: 'Broadcast content',
      operaTime: 'Operating time',
      sendTime: 'Release time',
      operaer: 'Operator',
      operatContent: 'Operation content',
      ignored: 'Checked',
      deleted: 'deleted',
      ban12hed: 'Broadcast blocked 12h',
      banBtned: 'Broadcast blocked',
      banDeviced: 'Banned devices',
      banIded: 'Banned id',
      araArea: 'Arabic Zone',
      enArea: 'English Zone',
      turArea: 'Turkish area',
      indArea: 'Indonesia Zone',
      level: 'Level',
      registraTime: 'Registration time',
      registerIp: 'Register ip',
      inTotal: 'There are {num} accounts',
      selectText1: 'broadcast',
      selectText2: 'Fan Gather',
      selectText3: 'Member Gather',
      selectText4: 'Guild Gather',
      selectText5: 'Unreviewed',
      selectText6: 'Audited',
      selectText7: 'deleted',
      convenedContent: 'Convened content',
      area: 'Area',
      table1Text1: 'Reviewer',
      table1Text2: 'Waiting time',
      table1Text3: 'Review time',
      table1Text4: 'Reviewer ID',
    },
    avatarReview: {
      userLiangId: 'User ID',
      pleaseEnterId: 'Please enter user ID',
      tabText1: 'Avatar review',
      tabText2: 'Violation record',
      pass: 'pass',
      reset: 'Reset data',
      ignore: 'Inspection passed',
      banId: 'ban ID',
      selectAll: 'select all',
      banDevice: 'Ban equipment',
      totalCount: 'There are {num} accounts',
      showBigImg: 'View Larger Image',
      ignored: 'Checked',
      reseted: 'Information reset',
      banDeviced: 'Ban devices',
      banIdTo: 'ban ID',
      resetTime: 'Reset time',
      auditor: 'Operator',
    },
    albumReview: {
      pageText1: 'Avatar review',
      status: 'Status',
      pageText2: 'Batch pass',
      pageText3: 'Bulk rejection',
      pageText4: 'Confirm to execute the pass operation',
      pageText5: 'Confirm rejection operation',
      pageText6: 'Pending review',
      pageText7: 'Audited',
      pageText8: 'Rejected',
      pageText9: 'An illegal processing',
      pageText10: 'Ignore the record',

      pageText11:'Are you sure to delete after warning?',
      pageText12:'Are you sure to ban square？',
    },
    reviewDetail: {
      choose: 'select',
      registerUser: 'registered user',
      nickname: 'nickname',
      country: 'country',
      deviceCode: 'Device code',
      wealth: 'wealth',
      charm: 'charm',
      activeLevel: 'Active level',
      registerIp: 'Register ip',
      regisTime: 'Registration time',
      lastLoginTime: 'last login time',
      userId: 'User id',
      pleaseEnterId: 'Please enter user ID',
      chooseAll: 'select all',
      reset: 'Reset data',
      banId: 'ban ID',
      banDevice: 'Ban equipment',
    },
    cstStatistics: {
      enterSearchId: 'Please enter ID query',
      startTime: 'Start Time',
      endTime: 'End Time',
      nickname: 'nickname',
      answer: 'Feedback Reply',
      idReview: 'ID review',
      activeReview: 'Active Review',
      bgReview: 'Room background review',
      banRecord: 'banned record',
      pass: 'Approval passed',
      refuse: 'Refuse to pass',
      banId: 'Ban ID',
      banDevice: 'ban device',
      adminGroup: 'Administrator group',
    },
    omtStatistics: {
      enterSearchId: 'Please enter ID query',
      startTime: 'Start Time',
      endTime: 'End Time',
      nickname: 'nickname',
      BrManage: 'Broadcast Management',
      avatarReview: 'Avatar review',
      machineReport: 'Machine Report',
      userReport: 'User Report',
      banRecord: 'banned record',
      pass: 'Approval passed',
      refuse: 'Refuse to pass',
      banId: 'Ban ID',
      banDevice: 'ban device',
      adminGroup: 'Administrator group',

      Photoalbumreview: 'Photo album review',
      Backgroundmanagement: 'Background management',
      Activitiestoapplyfor: 'Activities to apply for',
    },
    operationLog: {
      operator: 'Operator id',
      operater: 'User id',
      operaterRoomLabel: 'Room id',
      operaterRoom: 'id of the operated room',
      enterOperaterId: 'Please enter user id',
      enterOpertaterRoom: 'Please enter the room id',
      searchUser: 'Check users',
      searchRoom: 'Check the room',
      searchType: 'Search Type',


      enterSearchId: 'Please enter the operator ID query',
      enterIdInvalid: 'This ID is invalid.',
      startTime: 'Start Time',
      endTime: 'End Time',
      date: 'Date',
      adminId: 'Administrator id',
      adminName: 'Administrator Name',
      operatModule: 'Operation Module',
      operaContent: 'Operation content',
      reason: 'reason',
      module1: 'User information query',
      module2: 'Broadcast Management',
      module3: 'Avatar review',
      module4: 'Machine report',
      module5: 'User report',
      module6: 'ID audit',
      module7: 'Activity audit',
      module8: 'Room background review',
      module9: 'Front-end module',
      module10: 'Appeal Hall',
      module11: 'Community abnormal operation report',
      module12: 'Room query',
      module13: 'Customer Service Knowledge Base',
      module14: 'Customer Service Account Management',
      module15: 'Question Library',
      module16: 'family information query',
      module17: 'Posting permission',
      module18: 'topic management',
      module19: 'Post review',
      module20: 'Report management',
      module21: 'Auditor management',
      module22: 'Administrator',
      module23: 'Account blacklist management',
      module24: 'Administrator account',
      module25: 'Role Permissions',
      module26: 'Topic review',
      module27: 'Album review',
    },
    operateType: {
      // 封禁id，2解禁id,3封禁设备，4解禁设备，5封禁广播，6修改靓号，7重置资料，8通过,9拒绝,10反馈回复
      banId: 'ban id',
      unbanId: 'Unban id',
      banDevice: 'ban device',
      unbanDevice: 'Unban Device',
      banBroad: 'ban broadcast',
      updateId: 'Modify the nickname',
      reset: 'Reset data',
      pass: 'Examination passed',
      refuse: 'Refuse to pass',
      answer: 'Feedback Reply',
      delete: 'Delete',
      banRoom: 'banned room',
      unBanRoom: 'Unbanned Room',
      resetRoomInfo: 'Reset room information',
      unBanBoard: 'Unban broadcast ',
      updateOrAdd: 'Modify/Add',
      updateRoomBasic: 'Modify the basic information of the room',
      updateUserInfo: 'Modify user information',
      updateFamilyInfo: 'Modify basic family information',
      dropOff: 'On/Off shelf',
      recommendedPosts: 'Recommended Posts',
      blockPosts: 'Block Posts',
      mute: 'Mute',
      unMute: 'Unmute',
      upDateRoomId: 'Modify the room number',
    },
    nowMemberInroom: {
      enterId: 'Please enter the user id',
      userId: 'User ID',
      enterRoomTime: 'Time to enter the room',
      roomId: 'Room number',
    },
    loginFeedback: {
      date: 'Date',
      desc: 'Descrition',
      contact: 'Contact Information',
      imgOrVideo: 'Image or Vedio',
      equipment: 'Device',
      system: 'System Version',
      version: 'Version',
      showDetail: 'Details',
      enterStartAndEnd: 'Please fill in the start time and end time',
    },
    systemBlacklist: {
      userIPBlack: 'User IP blacklist',
      addBlack: 'Add blacklist users',
      userBlack: 'User blacklist',
      refuseLog: 'Denial of service log',
      errorLogin: 'Exception registration record',
      lastId: 'Last active ID',
      loginNum: 'Number of registered accounts',
      phoneLogin: 'Registered mobile number',
      fbLogin: 'Number of FB registrations',
      gugeLogin: 'Google registrations',
      refuseNum: 'Denial of service',
      lastRefuseTime: 'Last denial of service time',
      addTime: 'Date added',
      pleaseEnter: 'Please enter the passcode to complete the addition',
      delUser: 'Delete blacklisted users:{name}',
      passNum: 'Passcode',
      enterPassNum: 'Please enter the passcode to complete the operation',
      enterWarnText: 'Please fill in the complete ip and passcode',
      enterWarnIp: 'Please fill in the complete IP',
      enterWarnCode: 'Please fill in the complete passcode',
      refuseId: 'Denial of Service ID',
      refuseTime: 'Denial of service time',

      loginNum24: 'Number of registered accounts in 24h',
      phoneLogin24: '24h mobile phone number registration',
      fbLogin24: '24hFB registration number',
      gugeLogin24: '24 Google registrations',
      addToBlack: 'Add to blacklist',
    },
    activitySupport: {
      search1Text1: 'daily',
      search1Text2: 'weekly',
      search1Text3: 'per month',
      type: 'Types of',
      roomNumber: 'Room number',
      tableText1: 'Date',
      tableText2: 'Number of support rooms',
      tableText3: 'Support sessions',
      tableText4: 'Activity Flow',
      tableText5: 'Activity gift support value',
      tableText6: 'Proportion of support',
      tableText7: 'Activity ROI',
      tableText8: 'Proportion of non-compliant support',
      tableText9: 'Single games with more than 50W running water',
      tableText10: 'Flowing water above 50W in a single field',
      tableText11: 'Proportion of running water',
      tableText12: '5W-50W sessions',
      tableText13: '5W-50W running water',
      tableText14: 'Ratio of running water',
      tableText15: 'Sports under 5W',
      tableText16: 'flowing water below 5W',
      tableText17: 'Proportion of running water',
      tableText18: 'Proportion of non-compliant support',
    },
    couplePage: {
      table1Text1: 'Activity Type',
      table1Text2: 'Activity Title',
      table1Text3: 'Icon',
      table1Text4: 'url',
      table1Text5: 'Region',
      table1Text6: 'Start time',
      table1Text7: 'End time',
      table1Text8: 'Created time',
      table1Text9: 'Background Administrator',
      search1Text1: 'Room',
      search1Text2: 'CP',
      search1Text3: 'Activity Type',
      search1Text4: 'Click to upload a picture',
      search1Text5: 'Clear',
      search1Text6: 'Zhou Xing Zhou cp type',
      search1Text7: 'Old Zhou Xing',
      search1Text8: 'New week star',
      search1Text9: 'Week cp',
      search1Text10: 'Please enter the administrator id',
      errorMsg1: 'Please fill in completely',
      errorMsg2: 'Please upload icon',
      errorMsg3: 'Please select the start time and end time',
      errorMsg4: 'Confirm to delete this data',
    },
    gameStatistics: {
      game: 'Game',
      area: 'Area',
      country: 'Country',
      gameAll: 'Total number of games',
      gameStatus: 'Game Status',
      noRun: 'No escape',
      openNum: 'Opening number',
      peopleNum: 'proportion of people',
      complateGame: 'Complete the game',
      percent: 'Proportion',
      cancel: 'Actively cancel',
      timeOver: 'Timeout cancellation',
      numText: 'number',
      game2: '2-player game',
      game3: '3-player game',
      game4: '4-player game',
      areaText1: 'Bay area',
      areaText2: 'Turkey area',
      areaText3: 'other areas',
      overGameNum: 'Number of finishers',
      warDrum: 'War drum',
      game5: '2-4 rounds',
      game6: '5-8 people round',
      game7: '9-10 people round',
    },
    groupReview:{
      groupID:'Group ID',
      banGroup:'Ban group',
      banOwner:'Ban Owner',
      checkPending:'To be reviewed',
      checkPass:'checked',
      resetData:'Reset Data',
      operaTime:'Operation time',
      warningMsg:'warning',

      text:'Please enter the group ID/group owner ID',
      tabText1:'Report list',

      banReason:'Reasons for ban',
      banText:'content',

      ownerId:'Owner ID',
      userCount:'Group size',
      groupName:'Group Name',
      avatar:'Group Avatar',
      introduction:'introduction',
      blackList:'blacklist',

      banAction:'Ban',
      unBan:'Lift the ban',
      addTime:'Creation time',
      btnText1:'View Details',
      btnText2:'Kick out group',
      reset:'Reset Data',
      normal:'normal',
      permanentBan:'Permanent Ban',

      identity:'identity',
      tableText5:'Number of speeches',
      tableText6:'group turnover',
      title1:'Group member list',

      disBandGroup:'Disband group',
      disBand:'Disband',

    },
    // 房间专栏
    roomColumn: {
      bannerImg: 'Banner figure',

      tabText1: 'Room banner',
      tabText2: 'banner application',
      tabText3: 'Found page banner',

      table1Text1: 'sort',
      table1Text2: 'English',
      table1Text3: 'Arabic',
      table1Text4: 'Spanish',
      table1Text5: 'Turkish',
      table1Text6: 'Hindi',
      table1Text7: 'Vietnamese',
      table1Text8: 'Thai',
      table1Text9: 'Indonesia',
      table1Text10: 'Portuguese',
      table1Text11: 'Removal time',
      table1Text12: 'Cover image',
      table1Text13: 'big picture',
      table1Text14: 'Room',
      table1Text15: 'Already on shelves',
      table1Text16: 'Not listed',
      table1Text17: 'Region',
      table1Text18: 'Remove',
      table1Text19: 'On shelf',
      table1Text20: 'Shelf time',
      table1Text21: 'Added time',
      table1Text22: 'Time off',
      table1Text23: 'Note: Entering 1 means that the title is not displayed in this area.',
      table1Text24: 'Column Name (English)',
      table1Text25: 'Column name (Arabic)',
      table1Text26: 'Column name (Spanish)',
      table1Text27: 'Column name (Turkish)',
      table1Text28: 'Column name (Hindi)',
      table1Text29: 'Column name (Vietnamese)',
      table1Text30: 'Column name (Thai)',
      table1Text31: 'Column name (Indonesian)',
      table1Text32: 'Column name (Portuguese)',
      table1Text33: 'External image',
      table1Text34: 'Inner image',
      table1Text35: 'Jump Type',
      table1Text36: 'H5',
      table1Text37: 'Post',
      table1Text38: 'Topic',
      table1Text39: 'Internal picture room ID',
      table1Text40: 'URL',
      table1Text41: 'topic id/post id',
      table1Text42: 'Sort',
      table1Text43: 'Shelf time',
      table1Text44: 'Removal time',
      table1Text45: 'every day on shelf time',
      table1Text46: 'Daily removal time',
      table1Text47: 'Add and copy related functions',
      table1Text48: 'Please choose the type',
      table1Text49: 'Internal image binding ID',
      table1Text50: 'H5 link',
      table1Text51: 'Please enter the daily shelf time',
      table1Text52: 'Please enter the time of day off the shelf',
      table1Text53: 'Sort input box cannot be empty',
      table1Text54: 'External image cannot be empty',
      table1Text55: 'room',
      table1Text56: 'Event Details',
      table2Text57: 'Nationality',
      table2Text58: 'Room ID',
      table2Text59: 'Homeowner ID',
      table2Text59_1: 'Proposer ID',
      table2Text60: 'Activity Name',
      table2Text61: 'Activity start time',
      table2Text62: 'Activity duration',
      table2Text63: 'Activity Description',
      table2Text64: 'Social Media Account',
      table2Text65: 'Social media screenshot',
      table2Text66: 'Banner screenshot',
      table2Text67: 'banner application area',
      table2Text68: 'hour',
      table1Text69: 'Confirm to perform the listing operation',
      table1Text70: 'Confirm execution of delisting operation',
      table1Text71: 'Loading and unloading operations',
      table1Text72: 'Added time',
      table1Text73: 'Off-shelf time',
      table1Text74: 'The shelf time or the shelf time cannot be empty',
      table1Text75: 'Confirm delete operation',
      table2Text76: 'Confirm to execute the pass operation',
      table2Text77: 'Confirm rejection operation',
      table2Text78: 'Reason for rejection',

      table1Text78: 'URL',
      table1Text79: 'Post id',
      table1Text80: 'Topic id',
      table1Text81: 'The room id',
      table1Text82: 'Activity id',
      table1Text83: 'Please fill in the reason for refusal',

      table1Text84: 'Banner URL/ rule URL',
      table1Text85: 'Banner Room COLOR ID/Topic ID/Post ID',
      table1Text86: 'Whether to allow users to apply',
      table1Text87: 'Shelf time per day',
      table1Text88: 'Daily takedown time',
      table1Text89: 'Column room list',
      table1Text90: 'Certification level',
      table1Text91: 'Support activities this month',
      table1Text92: 'Room activities',
      table1Text93: 'Column activity',
      table1Text94: 'Picture size does not match',
      table1Text95: 'Picture size does not match',
      table1Text96: 'Column Support Activities',
      table1Text97: 'To add a banner',
      table1Text98: 'Add a column',
      table1Text99: 'Edit the banner',
      table1Text100: 'Edit the column',

      table1Text101: "Coming soon",
      table1Text102: "Applicant",
      table1Text103: "Please enter applicant",
      table1Text104: "Up rooms",
      table1Text105: "Down rooms",

      table2Text1: 'A blind date ',
      table2Text2: 'cricket',
      table2Text3: 'The film show',
      table2Text4: 'Talk show',
      table2Text5: 'music',
      table2Text6: 'Lucky dog',
      table2Text7: 'header',
      table2Text8: 'The wedding',
      table2Text9: 'birthday',
      table2Text10: 'Bachelor party',
      table2Text11: 'Banner Column type',
      table2Text12: 'The room list',

      table2Text13: 'Inner graph jump type',
      table2Text14: 'Inner map URL/ rule URL',
      table2Text15: 'Inside picture room id/ topic ID/post ID',
      table2Text16: 'bingo',
      table2Text17: 'Talent show',
      table2Text18: 'poetry',
      table2Text19: 'guessing',
      table2Text20: 'Room column',

      batchPass:'Batch Pass',
      batchReject:'Batch Reject',
      batchDelete:'Batch Delete',

      reviewedBy:'Reviewed by',
      reviewedTime:'Audit time',
      waitingTime:'Waiting time',

    },
    auditManageBg: {
      roomLiangId: 'Room number',
      status: 'Status',
      allAudit: "All",
      unAudit: 'Unreviewed',
      audited: 'Audited',
      roomNum: 'room number',
      roomBg: 'background',
      auditPass: 'examination passed',
      refused: 'be rejected',
      checkPass: 'Confirm execution of pass operation',
      checkRefuse: 'Confirm rejection',
      writeReason: 'Fill in the reason',
      checkBatchPass: 'Confirm the batch pass operation',
      checkBatchRefuse: 'Confirm batch rejection',
      batchPass: 'Batch pass',
      batchRefuse: 'Bulk rejection',
      toBeAudit:'To be audit',
    },
  },
  components: {
    banModal: {
      chooseTime: 'Choose a duration',
      chooseReason: 'Choose a reason:',
      content: 'Report Content:',
      enterContent: 'You can enter the report content',
      enterUrl: 'Image or Video Link:',
      imgVideoUrl: 'Image or Video Link:',
      // banUser: 'Confirm Banned Users?',
      banUser: 'Confirm the ban operation?',
      ban24: 'Ban 24 hours',
      ban72: 'Ban 72 hours',
      ban30D: 'Ban 30 days',
      permanentBan: 'Permanent ban',

      target:'Target',
    },
    loginForm: {
      enterUserName: 'Please Enter User Name',
      enterPassword: 'Please Enter The Password',
      login: 'Log In',
      accountNotNone: 'Account Cannot Be Empty',
      passwordNotNone: 'Password Can Not Be Empty',
    },
    fullScreen: {
      exitScreen: 'Exit full screen mode',
      fullScreen: 'Full Screen',
    },
    headerBar: {
      title: 'Starchat Multi-Country Service System V3.3',
    },
    tagsNav: {
      closeAll: 'Close All',
      closeOther: 'Close Other',
    },
    user: {
      signOut: 'Sign Out',
    },
    publicCheckPassword: {
      checkPassword: 'Enter and confirm the operation password',
      checkSuccess: 'Verify Successfully',
    },
    publicCheckBan: {
      checkBan: 'Security check',
      checkError: 'Check error',
      checkSuccess: 'Verify Successfully',
      nameNotNull: 'Can not be empty',
      enterUserName: 'Please enter the user name to verify',
    },
    tableBox: {
      noneData: 'No Data',
    },
    tableSearch: {
      search: 'Query Conditions',
    },
  },
  js: {
    request: {
      systemError: 'Server System Internal Error',
      unLogin: 'Did not logged in',
      timeOut: 'Request Timed Out',
      linkError: 'Network connection failed',
      requestServerError: 'Request to server failed, please try again',
      unknownMis: 'Unknown Error',
      postRemove: 'The post has been deleted, this operation is not allowed',
      commentRemove: 'Comment has been deleted, this operation is not allowed',
      postUnExist: 'Post does not exist',
      commentUnExist: 'Comment does not exist',
      postUnOpera: 'The post has been ignored, blocked or deleted, and can no longer be operated',
      commentUnOpera: 'The comment has been ignored, blocked or deleted.',
    },
  },

  home: {
    test: "测试"
  }
}



// WEBPACK FOOTER //
// ./src/language/en.js